import * as echarts from "echarts";
import chartDefinitions from "./industrialChartConfig.cjs";

export const {graphicTextStyle, grid, industrialChartConfig} = chartDefinitions;
export const timeFormatter = (value)=>{
    const time = echarts.time.format(value, '{MM}-{dd}/{HH}:{mm}', false);
    const arr = time.split('/')
    return arr[1] === '00:00' ? arr[0] : arr[1]
}
export const tooltipFormatter = (params,xunit = '',yunit = '')=>{
    const tooltipContent = params.map((item) => {
        return `
                <div >${item.value[0] + ' ' + xunit}</div>
                <div>
                  <span class="dian" style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background: ${item.color};"></span>
                  <span style="font-weight: bold">${item.value[1] + ' ' + yunit} </span>
                </div>
              `;
    }).join('');  // 使用 join 拼接成完整的 HTML 字符串
    return `<div>${tooltipContent}</div>`
}
export const spectrumToolButtons = ['addMark','doubleCursor','bandCount','harmonics','sideband','dataExport']

export const waveToolButtons = ['addMark','audio','doubleCursor','indicator','dataExport']
